import 'css-chunksrc/client/pages/zonesPage/wbsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_mnwbb_1",
  "text": "_text_mnwbb_17",
  "icon": "_icon_mnwbb_21"
};